/**
 * https://www.pdftron.com/api/web/Core.AnnotationManager.html#getAnnotationsList__anchor
 */
export default () => window.documentViewer.getAnnotationManager().getAnnotationsList();
